module.exports = __webpack_public_path__ + "28b2b9562a06614e324d4601528dc600.otf";